export default {
  getAttachment: state => state.attachment,
  getAttachments: state => state.attachments,
}
